/* eslint-disable camelcase */
import { postMessage } from 'src/utils/browserUtils';
import { MessageEventData, MessageEventType } from 'src/interfaces/MessageEvent';
import { v4 as uuidv4 } from 'uuid';
import TrackingService from '../TrackingService';
import ApplicationService from '../ApplicationService';

export default class MessageEventService extends TrackingService<MessageEventData> {
  getAggregateTimeWatched(watchtimes: number[]) {
    if (watchtimes.length === 0) return 0;
    return Math.floor(watchtimes.reduce((acc, cur) => acc + cur));
  }

  getAggregatePercentWatched(aggregateTimeWatched: number, mediaDuration: number) {
    if (mediaDuration === 0) return 0;
    return Math.floor((aggregateTimeWatched * 100) / mediaDuration);
  }

  track(event: MessageEventType) {
    const watchtimes = ApplicationService.player?.watchTimes?.map((time) => time.end - time.start) || [];

    const aggregate_time_watched = this.getAggregateTimeWatched(watchtimes);
    const aggregate_percent_watched = this.getAggregatePercentWatched(
      aggregate_time_watched,
      ApplicationService.playerData.mediaDuration || 0,
    );

    const eventData: MessageEventData = {
      id: '',
      event: event,
      media: {
        code: ApplicationService.playerData.code,
        duration: Math.floor(ApplicationService.playerData.mediaDuration),
        title: ApplicationService.playerParams.videoTitle || '',
        current_time: Math.floor(ApplicationService.player?.currentTime || 0),
        percent_watched: Math.floor(ApplicationService.player?.percentWatched || 0),
        aggregate_time_watched,
        aggregate_percent_watched,
      },
    };
    this.captureEvent(eventData);
  }

  captureEvent(event: MessageEventData) {
    if (this.isEventDuplicated(event)) return;
    postMessage({
      ...event,
      id: uuidv4(),
    });
  }
}
